import { gql } from '@apollo/client';

export const ActivitySessionFragments = gql`
  fragment ActivitySession on VOLUNTEER_SessionType {
    sessionId
    name
    description
    startTime
    endTime
    minVolunteers
    maxVolunteers
    isFlexible
    individualReports
    completedByCurrentVolunteer
    isOneOff
    activityDate
    currentFlexibleInstances {
      flexibleSessionInstanceId
      sessionDate
      startTime
      endTime
      name
    }
    reportType {
      reportTypeId
      name
      description
      items {
        ... on VOLUNTEER_ReportTypeFieldType {
          reportTypeItemId
          order
          optional
          field {
            fieldId
            name
            description
            isHero
            ... on VOLUNTEER_DropdownFieldType {
              isAllowMultiple
              dropdownOptions {
                dropdownFieldOptionId
                name
                order
              }
            }
            ... on VOLUNTEER_TextFieldType {
              isLongText
            }
          }
        }
        ... on VOLUNTEER_ReportTypeHeadingType {
          reportTypeItemId
          order
          heading
        }
      }
    }
    activityLocation {
      placesAddress {
        placesId
        description
        formatted
      }
    }
    activity {
      publishedRosters {
        rosterings {
          volunteer {
            volunteerId
          }
        }
      }
    }
    sessionReports {
      CICOs {
        CICOId
        checkIn
        checkOut
        volunteer {
          volunteerId
        }
        sessionReport {
          activityReport {
            activity {
              activityId
            }
            activityDate
          }
        }
      }
    }
    autoReport
    remoteLocation {
      activityRemoteLocationId
      details
    }
  }
`;
